export default __webpack_public_path__ + "static/media/Web 1280 ΓÇô 42.a0101603.jpg";